import { render, staticRenderFns } from "./UISimpleTickerCard.vue?vue&type=template&id=facca3d0"
import script from "./UISimpleTickerCard.vue?vue&type=script&lang=js"
export * from "./UISimpleTickerCard.vue?vue&type=script&lang=js"
import style0 from "./UISimpleTickerCard.vue?vue&type=style&index=0&id=facca3d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Img: require('/skade-pwa/components/ui/atom/Img.vue').default})
